import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterUnterpullendorf() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-unterpullendorf-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-unterpullendorf-heading">WETTER</h1>
        </div>

        <Wetter ort="unterpullendorf" />
      </div>
    </div>
  );
}

export default WetterUnterpullendorf;
